// extracted by mini-css-extract-plugin
export default {"dashboardImage":"style_dashboardImage__seSxO"};